import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";

export const getParameters = createAsyncThunk(
  "/parameters/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/parameters/getGeneralParameterByFirm");
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const parametersSlice = createSlice({
  name: "parameters",
  initialState: {
    parameters: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.parameters = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getParameters.fulfilled, (state, { payload }) => {
      state.parameters = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getParameters.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getParameters.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { changeSheetDetailStatus } = parametersSlice.actions;

export const parametersSelector = (state) => state.parameters;

export const parametersReducer = parametersSlice.reducer;
